import Vuex from 'vuex'
import Vue from 'vue'
import { fb } from '../utils/api.js'
import router from '@/router'

Vue.use(Vuex)

export const store = new Vuex.Store ({
  state: {
    user: {},
    factories: [],
    repgroups: [],
    featuredfactory: false,
    region: '',
    repgroup: false,
    currentreps: false,
    sidebar: true,
    newfactory: {
      id: false,
      business_name: '',
      phone: '',
      website: '',
      preferred: false,
      repgroups: {
        ak: '',
        can: '',
        co: '',
        hi: '',
        id: '',
        mt: '',
        or: '',
        tx: '',
        wa: '',
        wy: ''
      }
    },
    newrepgroup: {
      id: false,
      business_name: '',
      phone: '',
      website: ''
    },
    newrep: {
      id: false,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      note: ''
    },
    viewingrepid: '',
    addingrep: false
  },
  mutations: {
    setuser: (state, user) => {
      state.user = user
    },
    toggleaddrep: (state, val) => {
      state.addingrep = val
    },
    setviewingrepid: (state, val) => {
      state.viewingrepid = val
    },
    updateUser: (state) => {
      state.user = state.user
    },
    setfactories: (state, array) => {
      state.factories = array
    },
    addfactory: (state, obj) => {
      state.factories.push(obj)
      state.factories.sort((a,b) => {
        return (a.business_name < b.business_name? -1 : 1)
      })
      store.commit('resetfactoryform')
    },
    addrepgroup: (state, obj) => {
      state.repgroups.push(obj)
      state.repgroups.sort((a,b) => {
        return (a.business_name < b.business_name? -1 : 1)
      })
      store.commit('resetrepgroupform')
    },
    addrep: (state, obj) => {
      state.currentreps.push(obj)
      state.currentreps.sort((a,b) => {
        return (a.last_name < b.last_name? -1 : 1)
      })
      store.commit('resetrepform')
    },
    addrepfactory: (state, array) => {
      state.repgroup.factories = array
    },
    removerepgroup: (state, id) => {
      state.repgroups = state.repgroups.filter(g => g.id !== id)
    },
    removerep: (state, id) => {
      state.currentreps = state.currentreps.filter(r => r.id !== id)
    },
    removeFactory: (state, id) => {
      state.factories = state.factories.filter(f => f.id !== id)
    },
    resetfactoryform: (state) => {
      state.newfactory = {
        id: false,
        business_name: '',
        phone: '',
        website: '',
        preferred: false,
        repgroups: {
          ak: '',
          can: '',
          co: '',
          hi: '',
          id: '',
          mt: '',
          or: '',
          tx: '',
          wa: '',
          wy: ''
        }
      }
    },
    resetrepgroupform: (state) => {
      state.newrepgroup = {
        id: false,
        business_name: '',
        phone: '',
        website: ''
      }
    },
    resetrepform: (state) => {
      state.newrep = {
        id: false,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        note: ''
      }
    },
    setnewrep: (state, val) => {
      state.newrep = val
    },
    setnewfactory: (state, val) => {
      state.newfactory = val
    },
    setnewrepgroup: (state, val) => {
      state.newrepgroup = val
    },
    setrepgroups: (state, array) => {
      state.repgroups = array
    },
    setreps: (state, array) => {
      state.currentreps = array
    },
    setff: (state, obj) => {
      state.featuredfactory = obj
    },
    setrepgroup: (state, obj) => {
      state.repgroup = obj
    },
    setregion: (state, val) => {
      state.region = val
      localStorage.repregion = val
    },
    togglesidebar: (state) => {
      state.sidebar = !state.sidebar
    },
    set_repgroup_business_name: (state, val) => {
      state.newrepgroup.business_name = val
    },
    set_repgroup_phone: (state, val) => {
      state.newrepgroup.phone = val
    },
    set_repgroup_website: (state, val) => {
      state.newrepgroup.website = val
    },
    set_factory_business_name: (state, val) => {
      state.newfactory.business_name = val
    },
    set_factory_phone: (state, val) => {
      state.newfactory.phone = val
    },
    set_factory_website: (state, val) => {
      state.newfactory.website = val
    },
    set_factory_rep_ak: (state, val) => {
      state.newfactory.repgroups.ak = val
    },
    set_factory_rep_can: (state, val) => {
      state.newfactory.repgroups.can = val
    },
    set_factory_rep_co: (state, val) => {
      state.newfactory.repgroups.co = val
    },
    set_factory_rep_hi: (state, val) => {
      state.newfactory.repgroups.hi = val
    },
    set_factory_rep_id: (state, val) => {
      state.newfactory.repgroups.id = val
    },
    set_factory_rep_mt: (state, val) => {
      state.newfactory.repgroups.mt = val
    },
    set_factory_rep_or: (state, val) => {
      state.newfactory.repgroups.or = val
    },
    set_factory_rep_tx: (state, val) => {
      state.newfactory.repgroups.tx = val
    },
    set_factory_rep_wa: (state, val) => {
      state.newfactory.repgroups.wa = val
    },
    set_factory_rep_wy: (state, val) => {
      state.newfactory.repgroups.wy = val
    },
    set_rep_first_name: (state, val) => {
      state.newrep.first_name = val
    },
    set_rep_last_name: (state, val) => {
      state.newrep.last_name = val
    },
    set_rep_email: (state, val) => {
      state.newrep.email = val
    },
    set_rep_phone: (state, val) => {
      state.newrep.phone = val
    },
    set_rep_note: (state, val) => {
      state.newrep.note = val
    },

  },
  getters: {
    user: state => {
      return state.user
    }
  },
  actions: {
    getFactories: (state) => {
      console.log('fetching factories')
      var factoryArray = []
      fb.firestore().collection("factories")
      .orderBy('business_name')
      .get()
      .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              var docObj = doc.data()
              docObj.id = doc.id
              factoryArray.push(docObj)
          })
          state.commit('setfactories', factoryArray)
      }) 
    },
    getReps: (state, id) => {
      console.log('fetching reps with id: ' + id)
      state.state.currentreps = []
      var repArray = []
      fb.firestore().collection(`repgroups/${id}/reps`)
      .orderBy('last_name')
      .get()
      .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              var docObj = doc.data()
              docObj.id = doc.id
              repArray.push(docObj)
          })
          state.commit('setreps', repArray)
      })
      
    },
    getRepGroups: (state) => {
      console.log('fetching repgroups')
      var repgroupArray = []
      fb.firestore().collection("repgroups")
      .orderBy('business_name')
      .get()
      .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              var docObj = doc.data()
              docObj.id = doc.id
              repgroupArray.push(docObj)
          })
          state.commit('setrepgroups', repgroupArray)
      })
      
    },
    setFactory: (state, id) => {
      var factory = state.state.factories.find( f => f.id === id)
      if(!state.state.region){ state.state.region = 'ak'}
      store.commit('setff', factory)
    },
    setRepGroup: (state) => {
      if(state.state.featuredfactory){
        if(!state.state.region){ state.state.region = 'ak'}
        var repgroup = state.state.repgroups.find(r => r.id === state.state.featuredfactory.repgroups[state.state.region])
        if(repgroup){
          store.commit('setrepgroup', repgroup)
        } else {
          store.commit('setrepgroup', false)
        }
      }
    },
    createFactory: (state) => {
      if(state.state.newfactory.id){
        fb.firestore().collection("factories")
        .doc(state.state.newfactory.id)
        .set(state.state.newfactory)
        .then(function(docRef){
          store.commit('resetfactoryform')
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        fb.firestore().collection("factories")
        .add(state.state.newfactory)
        .then(function(docRef){
          var id = docRef.id
          docRef.get()
          .then(doc => {
            var factory = doc.data()
            factory.id = id
            store.commit('addfactory', factory)
          })
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    createRepGroup: (state) => {
      if(state.state.newrepgroup.id){
        fb.firestore().collection("repgroups")
        .doc(state.state.newrepgroup.id)
        .set(state.state.newrepgroup)
        .then(function(docRef){
          store.commit('resetrepgroupform')
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        fb.firestore().collection("repgroups")
        .add(state.state.newrepgroup)
        .then(function(docRef){
          var id = docRef.id
          docRef.get()
          .then(doc => {
            var repgroup = doc.data()
            repgroup.id = id
            store.commit('addrepgroup', repgroup)
          })
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    createRep: (state) => {
      if(state.state.newrep.id){
        fb.firestore().collection("repgroups")
        .doc(state.state.repgroup.id)
        .collection('reps')
        .doc(state.state.newrep.id)
        .set(state.state.newrep)
        .then(function(docRef){
          console.log('Yay! You edited the rep!')
          store.commit('resetrepgroupform')
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        fb.firestore().collection("repgroups")
        .doc(state.state.repgroup.id)
        .collection('reps')
        .add(state.state.newrep)
        .then(function(docRef){
          var id = docRef.id
          docRef.get()
          .then(doc => {
            var rep = doc.data()
            rep.id = id
            console.log(rep)
            store.commit('addrep', rep)
          })
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    addRepFactory: (state, id) => {
      var repRef = fb.firestore().collection("repgroups").doc(state.state.repgroup.id)
      fb.firestore().runTransaction(function(transaction) {
        return transaction.get(repRef)
        .then(function(doc){
          if(!doc.exists) { throw "RepGroup Document does not exist"}
          var newFactoryArray = doc.data().factories ? doc.data().factories : []
          if(!newFactoryArray.includes(id)){
            newFactoryArray.push(id)
          }
          transaction.update(repRef, {factories: newFactoryArray})
          return newFactoryArray
        })
      })
      .then(data => {
        console.log('Yay! Transaction worked!')
        store.commit('addrepfactory', data)
      })
      .catch(error => {
        console.log(error)
      })
    },
    removeRepFactory: (state, id) => {
      var repRef = fb.firestore().collection("repgroups").doc(state.state.repgroup.id)
      fb.firestore().runTransaction(function(transaction) {
        return transaction.get(repRef)
        .then(function(doc){
          if(!doc.exists) { throw "RepGroup Document does not exist"}
          var newFactoryArray = doc.data().factories ? doc.data().factories : []
          newFactoryArray = newFactoryArray.filter(f => f !== id)
          transaction.update(repRef, {factories: newFactoryArray})
          return newFactoryArray
        })
      })
      .then(data => {
        console.log('Yay! Transaction worked!')
        store.commit('addrepfactory', data)
      })
      .catch(error => {
        console.log(error)
      })
    },
    deleteRepGroup: (state, id) => {
      fb.firestore()
      .collection("repgroups")
      .doc(id)
      .delete()
      .then(data => {
        store.commit('removerepgroup', id)
      })
      .catch(error => {
        console.log(error)
      })
    },
    deleteRep: (state, id) => {
      fb.firestore()
      .collection("repgroups")
      .doc(state.state.repgroup.id)
      .collection('reps')
      .doc(id)
      .delete()
      .then(data => {
        store.commit('removerep', id)
      })
      .catch(error => {
        console.log(error)
      })
    },
    deleteFactory: (state, id) => {
      fb.firestore()
      .collection('factories')
      .doc(id)
      .delete()
      .then(() => {
        state.commit('removeFactory', id)
      })
      .catch(error => {
        console.log(error)
      })
    },
    signOut: (state) => {
      fb.auth().signOut()
      .then(() => {
        localStorage.repuser = null
        router.push('/auth')
      })
      .catch(error => {
        console.log(error)
      })
      
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js